import { render, staticRenderFns } from "./VfBreadcrumb.vue?vue&type=template&id=210b0e60&scoped=true"
import script from "./VfBreadcrumb.vue?vue&type=script&lang=js"
export * from "./VfBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./VfBreadcrumb.vue?vue&type=style&index=0&id=210b0e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b0e60",
  null
  
)

export default component.exports